export default __webpack_public_path__ + "assets/images/db356fabfda8065f0cc251818c22dae7.png";